import React, { useEffect } from "react"
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom"
import { connect } from "react-redux"
import { Home, Image } from "react-feather"

import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { isEmpty } from "../../helpers/object"
import { ROUTES } from "../../routes"

interface Props {
  auth?: any
  brand?: any
  preferences?: any
}

const BottomNavibar = (props: Props) => {
  const navigate = useNavigate()
  const location = useLocation()

  if (isEmpty(props.auth) || isEmpty(props.brand)) {
    return <></>
  }

  const isHomeMenu = location.pathname === "/" || location.pathname === "/campaigns" || location.pathname === "/postings"

  return (
    <>
      {props.preferences.isWebView && isHomeMenu && (
        <div className="pb-[60px]">
          <div className="fixed bottom-0 right-0 left-0 z-[1] bg-white border-t-[1px] border-gray-100 text-sm text-center">
            <div className="flex justify-around">
              <NavLink to={ROUTES.CAMPAIGN_INDEX.PATH} className="p-2">
                {({ isActive }) => (
                  <>
                    <Home className="mx-auto" fill={isActive ? "currentColor" : "none"} stroke={isActive ? "white" : "currentColor"} />
                    제품증정
                  </>
                )}
              </NavLink>
              <NavLink to={ROUTES.POSTING_INDEX.PATH} className="p-2">
                {({ isActive }) => (
                  <>
                    <Image className="mx-auto" fill={isActive ? "currentColor" : "none"} stroke={isActive ? "white" : "currentColor"} />
                    포스팅
                  </>
                )}
              </NavLink>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(BottomNavibar)
